import { navLinks, site } from "@/data/portfolioData";

export function Nav({ unlockedCount }) {
  return (
    <nav className="relative z-[5] flex flex-wrap items-center justify-between gap-4 px-6 py-7 md:px-14">
      <div className="flex items-center gap-2.5">
        <div className="flex h-9 w-9 items-center justify-center rounded-lg border-3 border-ink bg-periwinkle font-display text-base text-ink transition-transform hover:rotate-[-10deg] hover:scale-110">
          {site.initial}
        </div>
        <span className="font-display text-[19px] text-ink">{site.brand}</span>
      </div>

      <div className="hidden items-center gap-9 md:flex">
        {navLinks.map((link) => (
          <a
            key={link.href}
            href={link.href}
            className="font-semibold text-ink no-underline hover:text-teal"
          >
            {link.label}
          </a>
        ))}
      </div>

      <div className="flex items-center gap-2.5">
        <div className="neo-btn rounded-full bg-periwinkle px-5 py-2.5 text-base hover:rotate-[-3deg]">
          {site.years} Years
        </div>
        <div className="rounded-full border-3 border-ink bg-ink px-4 py-2.5">
          <span className="font-display text-sm text-green">
            🔓 {unlockedCount}/2
          </span>
        </div>
      </div>
    </nav>
  );
}
